import { useEffect, useState } from "react";
import { RequestError, useApi } from "../../services";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import { ErrorOnDialog } from "./errorModal";
import { useBarragemContext } from "../../context";
import { Oficio } from "../../services/api/oficios";
import { FileUpload } from "../fileUpload";
import { LoadingModal } from "./loadingModal";

interface NewOficioProps {
  open: boolean;
  onAdd?: (oficio: Oficio, file?: File) => void;
  onCancel?: () => void;
  initialOficio?: Oficio;
}

export const NewOficioModal: React.FC<NewOficioProps> = ({
  open,
  onAdd,
  onCancel,
  initialOficio,
}) => {
  const api = useApi();
  const { barragem } = useBarragemContext();

  const [error, setError] = useState<RequestError>();
  const [file, setFile] = useState<File>();
  const [percentage, setPercentage] = useState<number>();
  const [oficio, setOficio] = useState<Oficio>(initialOficio ?? {
    id: -1,
    idBarragem: -1,
    status: true,
    tipo: undefined,
    obs: undefined,
    idUpdate: "",
    dataCadastro: new Date(Date.now()),
  });

  useEffect(() => {
    if (!barragem || "error" in barragem) return;
    setOficio({ ...oficio, idBarragem: barragem.id });

  }, [barragem]);

  const handleConfirm = async () => {
    if (!file || oficio.idBarragem === -1) {
      setError({
        error: "Erro ao adicionar Ofício",
        message: "O arquivo deve ser selecionado",
      });
      return;
    }

    api.oficios.add(oficio.idBarragem, oficio).then(async (value) => {
      if ("error" in value) {
        setError(value);
        return;
      }

      const resp = await api.oficios.update(value, file, (percent) => setPercentage(percent));
      setPercentage(undefined);

      if ("error" in resp) {
        api.oficios.remove(value.id);
        setError(resp);
        return;
      }

      onAdd?.(resp, file);
      setOficio(resp);

    });
  };

  const handleCancel = () => {
    onCancel?.();
  };

  return <>
    {error && <ErrorOnDialog
      open={Boolean(error)}
      onClose={() => setError(undefined)}
      {...error}
    />}

    {percentage && <LoadingModal
      open={Boolean(percentage)}
      message={`Salvando ${percentage.toFixed(0)}%`}
    />}

    <Dialog
      open={open}
      maxWidth={"sm"}
      onClose={handleCancel}
    >
      <DialogTitle id="alert-dialog-title">Novo Ofício</DialogTitle>

      <DialogContent>
        <Box sx={{
          flex: 1,
          minHeight: "256px",
          gap: "0.5em",
          display: "flex",
          flexDirection: "row",
        }}>

          <Box sx={{
            flex: 1,
            gap: "0.5em",
            display: "flex",
            flexDirection: "column",
          }}>

            {/* Tipo */}
            <TextField fullWidth label="Tipo" variant="standard"
              value={oficio.tipo}
              onChange={(ev) => setOficio({
                ...oficio,
                tipo: ev.target.value,
              })}
            />

            {/* Observações */}
            <TextField fullWidth multiline label="Observações" variant="standard"
              value={oficio.obs}
              onChange={(ev) => setOficio({
                ...oficio,
                obs: ev.target.value
              })}
            />
          </Box>

          <Box sx={{
            flex: 1,
            display: "flex",
            overflow: "auto",
            flexDirection: "column",
          }}>
            <FileUpload
              sx={{ flex: 1 }}
              accept={{
                'application/pdf': []
              }}
              files={file ? [file] : undefined}
              onAddFile={(files) => setFile(files && files.length > 0 ? files[0] : undefined)}
            />
          </Box>

        </Box>

      </DialogContent>


      <DialogActions>
        <Button variant="contained" onClick={handleCancel}>
          Cancelar
        </Button>
        <Button onClick={handleConfirm} autoFocus>
          Confirmar
        </Button>
      </DialogActions>
    </Dialog >
  </>;
};